<fieldset>
 <legend>
  TypeTravaux
 </legend>
 <app-form-input 
[parentForm]="parentForm" 
[value]="marcheTravaux.execution" 
 
[label]="'execution'"
[type]="'text'"
[rule]="''"
[name]="getUid()+'_SepAtt_execution'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm" 
[value]="marcheTravaux.conceptionRealisation" 
 
[label]="'conceptionRealisation'"
[type]="'text'"
[rule]="''"
[name]="getUid()+'_SepAtt_conceptionRealisation'">
</app-form-input>
</fieldset>